import { useMutation } from '@tanstack/react-query';
import { useAPIQuery } from 'shared/api/APIQuery';
import { APIResponse } from 'shared/api/CarrierAPIClient';
import {
  LoadboardAPIResponse,
  requestJSONLoadboardAPI,
} from 'shared/api/LoadboardAPIClient';
import { yupArray } from 'shared/utils/YupUtils';
import {
  NotificationsSettingDTO,
  NotificationsSettingPayloadDTO,
  notificationsSettingPayloadSchema,
  notificationsSettingSchema,
} from './LoadboardNotificationsSettingDTO';
import {
  LoadboardSubscriptionSettingsDTO,
  loadboardSubscriptionSettingsSchema,
} from './LoadboardUserSettingsDTO';

export function useUserSettings() {
  return useAPIQuery(
    ['loadboard', 'subscription-settings'],
    () =>
      requestJSONLoadboardAPI<APIResponse<LoadboardSubscriptionSettingsDTO>>(
        'GET /internal/v3/settings/subscription',
      ),
    { schema: loadboardSubscriptionSettingsSchema },
  );
}

export function useNotificationsSettings() {
  return useAPIQuery(
    ['loadboard', 'notification-settings'],
    () =>
      requestJSONLoadboardAPI<APIResponse<NotificationsSettingPayloadDTO[]>>(
        'GET /internal/v3/settings/notifications',
      ),
    {
      staleTime: Infinity,
      gcTime: Infinity,
      schema: yupArray(notificationsSettingPayloadSchema).defined(),
    },
  );
}

export function useUpdateNotificationsSettings() {
  return useMutation({
    mutationFn: (payload: NotificationsSettingPayloadDTO[]) =>
      requestJSONLoadboardAPI<LoadboardAPIResponse<NotificationsSettingDTO[]>>(
        'PUT /internal/v3/settings/notifications',
        { json: payload },
      ).then((response) => {
        response.data = response.data.map((x) =>
          notificationsSettingSchema.cast(x),
        );
        return response;
      }),
  });
}
